// extracted by mini-css-extract-plugin
export var customToastMessage = "CustomToastMessage-module--customToastMessage--7e483";
export var lmsScrollbar = "CustomToastMessage-module--lms-scrollbar--3a857";
export var toastDescription = "CustomToastMessage-module--toastDescription--a79ee";
export var toastNegative = "CustomToastMessage-module--toastNegative--31f4f";
export var toastPositive = "CustomToastMessage-module--toastPositive--5ec10";
export var toastTitle = "CustomToastMessage-module--toastTitle--c5f57";
export var toastWarning = "CustomToastMessage-module--toastWarning--9fe73";